/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  OrderHistoryReducer.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 : Order History
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422336
 *
 * @Date         : Sep 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H422336
 * On            : Nov, 5 2020
 * Description   : ASDS-4016 UI Enhancements for Phase-II
 *
 ******************************************************************************/
import Reducer from './reducer';
import CheckoutActionConstants from '../action-constants';
import { createReducer } from '../utils/redux-util';
import { AsdsReducerObject } from '../../../../../types';
import { AsdsReduxAction } from 'types';

class OrderHistoryReducer extends Reducer {
    static getOrderHistory(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            ...state,
            payload: {
                isSuccess: action.payload.isSuccess,
                isFetching: action.payload.isFetching,
            },
            orders: action.payload.orders
        };
    }

    static updateFilters(state, action: AsdsReduxAction) {
        return {
            ...state,
            filters: action.payload.filters,
            filtersCount: action.payload.filtersCount
        };
    }

    static processingRequest(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            ...state,
            isProcessingRequest: action.payload.isProcessingRequest,
        };
    }

    static setSoldToOptions(state, action: AsdsReduxAction): AsdsReducerObject {
        return {
            ...state,
            soldTos: action.payload.soldTos
        };
    }
}

const userHandlers = {
    [CheckoutActionConstants.GET_ORDER_HISTORY]: OrderHistoryReducer.getOrderHistory,
    [CheckoutActionConstants.SET_SOLD_TO_OPTIONS]: OrderHistoryReducer.setSoldToOptions,
    [CheckoutActionConstants.PROCESSING_ORDER_REQUEST]: OrderHistoryReducer.processingRequest,
    [CheckoutActionConstants.UPDATE_ORDER_FILTERS]: OrderHistoryReducer.updateFilters,
};

const initialState = {
    payload: {
        isSuccess: true,
        isFetching: false,
    },
    orders: [],
    isProcessingRequest: false,
    soldTos: [],
    filters: {
        status: '',
        soldTo: '',
        toDate: '',
        fromDate: '',
        reset: false
    },
    filtersCount: 0
};

export const orderHistoryData = createReducer(initialState, userHandlers);
